import { HugerteEditor, NumberInput, TextareaInput } from 'components/FormControl';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line no-unused-vars
export default function KPITable({ kpiTable, proposedExpenditure, control, errors }) {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t('projectProposal.researchResult.kpis.label')}</h4>
      <div className="form-table">
        <table className="mb-2">
          <thead>
            <tr>
              <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('projectProposal.researchResult.kpis.fields.order')}
              </th>
              <th className="text-center" style={{ minWidth: 300, width: 400 }}>
                {t('projectProposal.researchResult.kpis.fields.KPI')}
              </th>
              <th className="text-center" style={{ minWidth: 170, width: 170 }}>
                {t('projectProposal.researchResult.kpis.fields.numberRegistration')}
              </th>
              <th className="text-center" style={{ minWidth: 300, width: '100%' }}>
                {t('projectProposal.researchResult.kpis.fields.content')}
              </th>
            </tr>
          </thead>
          {kpiTable.map((kpiGroup) => (
            <tbody key={kpiGroup[1].id}>
              {kpiGroup[1].kpis.map((kpi, index) => (
                <tr key={kpi.id}>
                  {index === 0 ? (
                    <td className="text-center font-bold" rowSpan={kpiGroup[1].kpis.length}>
                      {kpiGroup[0]}
                    </td>
                  ) : (
                    <td className="hidden" />
                  )}
                  <td>
                    {t('lang') === 'vi'
                      ? kpi.name
                      : kpi.englishName || t(`projectProposal.researchResult.kpis.kpi.${kpi.code}`)}
                  </td>
                  <td>
                    <NumberInput
                      name={`researchResult.projectProposalResearchKpis.${kpi.id}.quantity`}
                      control={control}
                      errors={errors}
                    />
                  </td>
                  <td>
                    <TextareaInput
                      name={`researchResult.projectProposalResearchKpis.${kpi.id}.content`}
                      control={control}
                      errors={errors}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </div>
      <div className="mt-4">
        <h4 className="text-lg text-red-500">
          {t('projectProposal.researchResult.kpis.k9_details')}
        </h4>
        <HugerteEditor name="general.k9Details" control={control} errors={errors} />
      </div>
    </div>
  );
}

KPITable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  kpiTable: PropTypes.array,
  proposedExpenditure: PropTypes.number,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
};

KPITable.defaultProps = {
  kpiTable: [],
  proposedExpenditure: 0,
};
